export const APP_ID = "225284c7d2a01b81"
export const APP_REGION = "us"
export const AUTH_KEY = "b789fa26dcbe3c67416639d931cf6770b61d7a97"